// ドロワーメニュー関連の処理
const initDrawer = () => {
  const menuButton = document.getElementById("js-menu");
  const menuButtonJapan = document.getElementById("js-menu-japan");
  const drawer = document.getElementById("js-drawer");
  const drawerJapan = document.getElementById("js-drawer-japan");
  const drawerMenu = document.getElementById("js-drawer-menu");


  if (!menuButton || !drawer || !drawerMenu) return;
  if (!menuButtonJapan || !drawerJapan) return;

  const drawerAnchorLinks = drawerMenu.querySelectorAll('a[href*="#"]');

  // ドロワーメニューを展開する処理
  const openDrawer = (button, drawerElement) => {
    button.setAttribute("aria-expanded", "true");
    drawerElement.setAttribute("aria-hidden", "false");
    drawerElement.inert = false;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  };

  // ドロワーメニューを閉じる処理
  const closeDrawer = (button, drawerElement) => {
    button.setAttribute("aria-expanded", "false");
    drawerElement.setAttribute("aria-hidden", "true");
    drawerElement.inert = true;
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  };

  // 通常のドロワーメニューを開く
  const openMainDrawer = () => {
    closeDrawer(menuButtonJapan, drawerJapan);
    openDrawer(menuButton, drawer);
  };

  // 通常のドロワーメニューを閉じる
  const closeMainDrawer = () => {
    closeDrawer(menuButton, drawer);
  };

  // 日本地図のドロワーメニューを開く
  const openJapanDrawer = () => {
    closeDrawer(menuButton, drawer);
    openDrawer(menuButtonJapan, drawerJapan);
  };

  // 日本地図のドロワーメニューを閉じる
  const closeJapanDrawer = () => {
    closeDrawer(menuButtonJapan, drawerJapan);
  };

  // すべてのドロワーメニューを閉じる
  const closeAllDrawers = () => {
    closeMainDrawer();
    closeJapanDrawer();
  };

  // ハンバーガーメニューをクリックした時の処理
  menuButton.addEventListener("click", () => {
    if (menuButton.getAttribute("aria-expanded") === "true") {
      closeMainDrawer();
    } else {
      openMainDrawer();
    }
  });

  // 日本地図メニューボタンをクリックした時の処理
  menuButtonJapan.addEventListener("click", () => {
    if (menuButtonJapan.getAttribute("aria-expanded") === "true") {
      closeJapanDrawer();
    } else {
      openJapanDrawer();
    }
  });

  // ページ内リンクをクリックしたとき、ドロワーメニューを閉じる
  drawerAnchorLinks.forEach((link) => {
    link.addEventListener("click", () => {
      closeMainDrawer();
    });
  });

  // 通常のドロワーメニュー以外の要素をクリックしたとき、ドロワーメニューを閉じる
  drawer.addEventListener("click", (event) => {
    if (
      (drawerMenu && drawerMenu.contains(event.target)) ||
      (menuButton && menuButton.contains(event.target))
    )
      return;

    closeMainDrawer();
  });

  // 日本地図のドロワーメニュー以外の要素をクリックしたとき、ドロワーメニューを閉じる
  drawerJapan.addEventListener("click", (event) => {
    const drawerJapanContent = drawerJapan.querySelector('.p-drawer-japan__areas');
    if (
      (drawerJapanContent && drawerJapanContent.contains(event.target)) ||
      (menuButtonJapan && menuButtonJapan.contains(event.target))
    )
      return;

    closeJapanDrawer();
  });

  // ブレイクポイントを超えたとき、通常のドロワーメニューを閉じる（drawerJapanは閉じない）
  const mediaQuery = window.matchMedia('(min-width: 1024px)');
  const handleMediaChange = (e) => {
    if (e.matches) {
      closeMainDrawer();
    }
  };
  
  // 初期状態のチェック
  if (mediaQuery.matches) {
    closeMainDrawer();
  }
  
  // メディアクエリの変更を監視
  mediaQuery.addEventListener('change', handleMediaChange);

  // デバッグ用
// openDrawer(menuButtonJapan, drawerJapan); // Drawer Japanを開く
// openeDrawer(menuButton, drawer); // Drawerを開く

};

// type="module"のスクリプトはDOMContentLoadedの後に実行されるため、単純に呼び出すだけで良い
initDrawer();

